import Select from "react-select";
import makeAnimated from "react-select/animated";

const animatedComponents = makeAnimated();

export default function Multiselect({
  label,
  inputName,
  onBlurMethod,
  value,
  isRequired,
  touched,
  errors,
  optionsArray,
  isDisabled,
  multiselect,
  optionValue,
  optionName,

  //Si obtiene el metodo setFieldValue lo ejecutara, en caso contrario ejecutara un metodo onChangeMethod
  setFieldValue,
  onChangeMethod,
}: //retorna un nuevo array [{},{},{}],
{
  label: string;
  inputName: string;
  onBlurMethod: any;
  value: Array<any>;
  isRequired: boolean;
  touched: any;
  errors: any;
  optionsArray: Array<any>;
  isDisabled?: boolean;
  multiselect: boolean;
  optionValue: string;
  optionName: string;
  //Si obtiene el metodo setFieldValue lo ejecutara en caso contrario ejecutara un metodo onChangeMethod
  setFieldValue?: any;
  onChangeMethod?: any;
}) {
  return (
    <div className="form-group">
      <label htmlFor={inputName}>
        {label} {isRequired && <span className="text-danger">*</span>}
      </label>
      <Select
        closeMenuOnSelect={!multiselect}
        isMulti={multiselect}
        components={animatedComponents}
        defaultValue={[]}
        options={optionsArray}
        className={errors && touched ? " is-invalid" : ""}
        name={inputName}
        id={inputName}
        onChange={
          setFieldValue
            ? (valueChanged) => setFieldValue(inputName, valueChanged)
            : onChangeMethod
        }
        onBlur={onBlurMethod}
        value={value}
        isDisabled={isDisabled}
        getOptionLabel={(option: any) => {
          return option[optionName];
        }}
        getOptionValue={(option: any) => {
          return option[optionValue];
        }}
      />
      {touched && errors && <span style={{ color: "red" }}>{errors}</span>}
    </div>
  );
}
